import { createReducer, on } from '@ngrx/store';

import { goToProjects, setProject } from '../../core/store';
import {
	bulkDeleteMedias,
	deleteMedia,
	deleteMediaFail,
	deleteMediaSuccess,
	fetchMediaListFail,
	fetchMediaListSuccess,
	initMediaList,
	refreshMediaList,
	updateIncludePublic,
} from './media.actions';
import { MediaOriginalSliceState } from './media.state';

export const mediaOriginalReducer = createReducer<MediaOriginalSliceState>(
	new MediaOriginalSliceState(),
	on(goToProjects, setProject, (state) => state.clear()),
	on(initMediaList, refreshMediaList, (state) => state.setLoading(true)),
	on(fetchMediaListSuccess, (state, action) =>
		state.setLoading(false).setMediaList(action.mediaList)
	),
	on(fetchMediaListFail, (state) => state.setLoading(false)),
	on(updateIncludePublic, (state, action) =>
		state.setLoading(true).toggleIncludePublicProjects(action.includePublic)
	),
	on(deleteMedia, bulkDeleteMedias, (state) => state.setLoading(true)),
	on(deleteMediaSuccess, (state) => state.setDeleteSuccess(true)),
	on(deleteMediaFail, (state) =>
		state.setDeleteSuccess(false).setLoading(false)
	)
);
